// removed by extract-text-webpack-plugin
module.exports = {"unordered":"type__unordered___1tJxb listStyle-disc","ordered":"type__ordered___2YVb6 listStyle-decimal"};


//////////////////
// WEBPACK FOOTER
// ./packages/marvel-ui-list/List/style/type.css
// module id = 183
// module chunks = 0 25